import { Link } from 'react-router';
import { Brand } from './Brand.jsx';
import { Wrap } from '../ui/Section.jsx';
import { site, contact, hours, footerLinks } from '../../data/site.js';
import styles from './Footer.module.css';

export function Footer() {
  return (
    <footer className={styles.footer}>
      <Wrap>
        <div className={styles.top}>
          <div className={styles.brandCol}>
            <Brand onDark />
            <p>{site.tagline}</p>
          </div>

          {/* h2, not h4: these are the first headings below the page's own
              content, and jumping straight to h4 skipped two levels. */}
          <div className={styles.col}>
            <h2>Explore</h2>
            <ul>
              {footerLinks.map(({ to, label }) => (
                <li key={to}>
                  <Link to={to}>{label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className={styles.col}>
            <h2>Contact</h2>
            <ul>
              <li><a href={contact.phoneHref}>{contact.phone}</a></li>
              <li><a href={contact.emailHref}>{contact.email}</a></li>
              <li><p>{site.location}</p></li>
            </ul>
          </div>

          <div className={styles.col}>
            <h2>Hours</h2>
            <ul>
              {hours.map(({ days, time }) => (
                <li key={days}><p>{days}: {time}</p></li>
              ))}
            </ul>
          </div>
        </div>

        <div className={styles.bottom}>
          <span>&copy; {site.founded} {site.name}. All rights reserved.</span>
          <span>Est. {site.founded} &middot; {site.locationLong}</span>
        </div>
      </Wrap>
    </footer>
  );
}
